import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constants";
import { hideLoaderAction, showLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";
import { uploadImages } from "./uploadFiles";

const getDemoVideo = () => async (dispatch) => {
    dispatch(showLoaderAction());

    const res = await api("get", Constants.END_POINT.DEMO_VIDEO);
    if (res.success) {
        dispatch({
            type: types.DEMO_VIDEO,
            payload: res.data,
        });
    }
    dispatch(hideLoaderAction());
};

const saveOrUpdateDemoVideo =
    (data, dispatch1, setLoading) =>
    async (dispatch) => {
        dispatch(showLoaderAction());
        setLoading(true);

        // Upload video file if it's a new file (not already a URL string)
        if (data?.video?.length) {
            let urls = await uploadImages(data.video, dispatch1);
            data.videoUrl = urls[0];
        }

        // Upload thumbnail if it's a new file
        if (data?.thumbnail?.length) {
            let urls = await uploadImages(data.thumbnail, dispatch1);
            data.thumbnailUrl = urls[0];
        }

        const payload = {
            title: data.title,
            description: data.description,
            videoUrl: data.videoUrl,
            thumbnailUrl: data.thumbnailUrl,
        };

        const res = await api("post", Constants.END_POINT.DEMO_VIDEO, payload);
        if (res.success) {
            dispatch(showToast({ severity: "success", summary: res.message }));
            dispatch(getDemoVideo());
        } else {
            dispatch(showToast({ severity: "error", summary: res.message }));
        }
        setLoading(false);
        dispatch(hideLoaderAction());
    };

const deleteDemoVideo = () => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("delete", Constants.END_POINT.DEMO_VIDEO);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch({
            type: types.DEMO_VIDEO,
            payload: null,
        });
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

export { getDemoVideo, saveOrUpdateDemoVideo, deleteDemoVideo };
